<template>
  <div class="container mt-4">
    <!-- Breadcrumb -->
    <b-breadcrumb class="m-3">
      <b-breadcrumb-item href="/">
        <i class="fa fa-home" aria-hidden="true"></i> Home</b-breadcrumb-item
      >
      <b-breadcrumb-item href="/residentslist-adl">
        Residents</b-breadcrumb-item
      >
      <b-breadcrumb-item active> {{ getBread("-adl") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <div class="customCard">
      <h1 style="font-size: 2rem; text-align: center; padding-bottom: 1rem">
        List of ADL {{ fullName }}
      </h1>
    </div>

    <div v-if="loading" class="text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else-if="error" class="text-center text-danger">
      <p>Error loading data.</p>
    </div>
    <div v-else>
      <div v-if="getUserRole('carers')">
        <button class="btn btn-primary mb-4" @click="showAddModal = true">
          Add ADL
        </button>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">ADL</th>
            <th scope="col">ADL Type</th>
            <th scope="col">Detail</th>
            <th scope="col">Status</th>
            <th
              scope="col"
              v-if="getUserRole('carers') || getUserRole('editors')"
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="adl in paginatedAdls" :key="adl.id">
            <td>
              <a href="#" @click.prevent="viewEntry(adl)">{{
                getAdlActivities(adl.attributes.adl)
              }}</a>
            </td>
            <td>{{ getAdlTypeText(adl.attributes.adltype) }}</td>
            <td>{{ adl.attributes.detail }}</td>
            <td>{{ adl.attributes.status }}</td>
            <td v-if="getUserRole('carers') || getUserRole('editors')">
              <a href="#" @click.prevent="editEntry(adl)">Edit</a>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-between align-items-center">
        <p>
          Showing {{ startIndex + 1 }} to {{ endIndex }} of
          {{ result.residentadls.data.length }} entries
        </p>
        <ul class="pagination">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(currentPage - 1)"
              >Prev</a
            >
          </li>
          <li
            class="page-item"
            v-for="page in totalPages"
            :key="page"
            :class="{ active: currentPage === page }"
          >
            <a class="page-link" href="#" @click.prevent="changePage(page)">{{
              page
            }}</a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: currentPage === totalPages }"
          >
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(currentPage + 1)"
              >Next</a
            >
          </li>
        </ul>
      </div>
    </div>

    <!-- View Modal -->
    <b-modal
      size="xl"
      v-model="showViewModal"
      hide-footer
      :title="'View ADL ' + fullName"
    >
      <form v-if="currentAdl" @submit.prevent="updateEntry">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="adl" class="form-label">ADL</label>
              <select
                class="form-select"
                id="adl"
                v-model="currentAdl.attributes.adl"
                required
                :disabled="true"
              >
                >
                <option
                  v-for="option in adlActivities"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label for="startdate" class="form-label">Start Date</label>
              <input
                type="date"
                class="form-control"
                id="startdate"
                v-model="currentAdl.attributes.startdate"
                required
                :disabled="true"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="detail" class="form-label">Detail</label>
              <textarea
                class="form-control"
                id="detail"
                v-model="currentAdl.attributes.detail"
                :disabled="true"
              ></textarea>
              <div class="mb-3">
                <label for="enddate" class="form-label">End Date</label>
                <input
                  type="date"
                  class="form-control"
                  id="startdate"
                  v-model="currentAdl.attributes.enddate"
                  :disabled="true"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="adltype" class="form-label">ADL Type</label>
              <select
                class="form-select"
                id="adltype"
                v-model="currentAdl.attributes.adltype"
                required
                :disabled="true"
              >
                <option
                  v-for="option in adlTypes"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div class="mb-3" v-if="isRoutine(currentAdl.attributes.adltype)">
              <label for="remindTypes" class="form-label">Remind</label>
              <div class="input-group">
                <select
                  class="form-select"
                  id="remind"
                  v-model="currentAdl.attributes.remind"
                  required
                  :disabled="true"
                >
                  <option
                    v-for="option in remindTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
                <select
                  class="form-select"
                  id="minute"
                  v-model="currentAdl.attributes.minute"
                  required
                  :disabled="true"
                >
                  <option
                    v-for="option in minuteTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="d-grid">
            <!-- <button type="submit" class="btn btn-primary">Save changes</button> -->
          </div>
        </div>

        <!-- Schedules -->
        <h5>Schedules</h5>
        <div class="row" v-for="sched in currentSchedules" :key="sched.id">
          <hr />

          <div class="col-md-4">
            <div class="mb-3">
              <label for="time" class="form-label">Time </label>
              <input
                type="time"
                class="form-control"
                id="time"
                v-model="sched.attributes.time"
                required
                :disabled="true"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="type" class="form-label">Type</label>
              <select
                class="form-select"
                id="type"
                v-model="sched.attributes.type"
                required
                :disabled="true"
              >
                <option
                  v-for="option in scheduleTypes"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="detail" class="form-label">Detail</label>
              <div v-if="isDaily(sched.attributes.type)">
                <div class="d-flex flex-wrap">
                  <div
                    class="form-check me-3"
                    v-for="day in ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su']"
                    :key="day"
                  >
                    <label class="form-check-label">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="sched.attributes[day]"
                        :disabled="true"
                      />
                      {{ day.charAt(0).toUpperCase() + day.slice(1) }}
                    </label>
                  </div>
                </div>
              </div>
              <div v-if="isDWeek(sched.attributes.type)">
                <div class="d-flex flex-wrap">
                  <div
                    class="form-check me-3"
                    v-for="day in ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su']"
                    :key="day"
                  >
                    <label class="form-check-label">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="sched.attributes[day]"
                        :disabled="true"
                      />
                      {{ day.charAt(0).toUpperCase() + day.slice(1) }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-grid">
          <!-- <button type="submit" class="btn btn-primary">Save changes</button> -->
        </div>
      </form>
      <div v-if="updateError" class="alert alert-danger mt-3">
        {{ updateError }}
      </div>
    </b-modal>

    <!-- Edit Modal -->
    <b-modal
      size="xl"
      v-model="showEditModal"
      hide-footer
      :title="'Edit ADL ' + fullName"
    >
      <form v-if="currentAdl" @submit.prevent="updateEntry">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="adl" class="form-label">ADL</label>
              <select
                class="form-select"
                id="adl"
                v-model="currentAdl.attributes.adl"
                required
              >
                <option
                  v-for="option in adlActivities"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label for="startdate" class="form-label">Start Date</label>
              <input
                type="date"
                class="form-control"
                id="startdate"
                v-model="currentAdl.attributes.startdate"
                required
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="detail" class="form-label">Detail</label>
              <textarea
                class="form-control"
                id="detail"
                v-model="currentAdl.attributes.detail"
              ></textarea>
              <div class="mb-3">
                <label for="enddate" class="form-label">End Date</label>
                <input
                  type="date"
                  class="form-control"
                  id="startdate"
                  v-model="currentAdl.attributes.enddate"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="adltype" class="form-label">ADL Type</label>
              <select
                class="form-select"
                id="adltype"
                v-model="currentAdl.attributes.adltype"
                required
              >
                <option
                  v-for="option in adlTypes"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div class="mb-3" v-if="isRoutine(currentAdl.attributes.adltype)">
              <label for="remindTypes" class="form-label">Remind</label>
              <div class="input-group">
                <select
                  class="form-select"
                  id="remind"
                  v-model="currentAdl.attributes.remind"
                  required
                >
                  <option
                    v-for="option in remindTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
                <select
                  class="form-select"
                  id="minute"
                  v-model="currentAdl.attributes.minute"
                  required
                >
                  <option
                    v-for="option in minuteTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <!-- Schedules  Edit-->
        <h5>Schedules</h5>
        <hr />

        <div class="row" v-for="sched in currentSchedules" :key="sched.id">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="time" class="form-label">Time</label>
              <input
                type="time"
                class="form-control"
                id="time"
                v-model="sched.attributes.time"
                required
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="type" class="form-label">Type</label>
              <select
                class="form-select"
                id="type"
                v-model="sched.attributes.type"
                required
              >
                <option
                  v-for="option in scheduleTypes"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="detail" class="form-label">Detail</label>
              <div v-if="isDaily(sched.attributes.type)">
                <div class="d-flex flex-wrap">
                  <div
                    class="form-check me-3"
                    v-for="(day, index) in days"
                    :key="index"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'checkbox' + index"
                      v-model="sched.selectedDays"
                      :value="day"
                      :disabled="isDaily(sched.attributes.type)"
                    />

                    <label class="form-check-label" :for="'checkbox' + index">
                      {{ day }}
                    </label>
                  </div>
                </div>
              </div>
              <div v-if="isDWeek(sched.attributes.type)">
                <div class="d-flex flex-wrap">
                  <div
                    class="form-check me-3"
                    v-for="(day, index) in days"
                    :key="index"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'checkbox' + index"
                      v-model="sched.selectedDays"
                      :value="day"
                    />

                    <label class="form-check-label" :for="'checkbox' + index">
                      {{ day }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-grid">
          <button type="submit" class="btn btn-primary">Save changes</button>
        </div>
      </form>
      <div v-if="updateError" class="alert alert-danger mt-3">
        {{ updateError }}
      </div>
    </b-modal>

    <!-- Add Modal -->
    <b-modal
      size="xl"
      v-model="showAddModal"
      hide-footer
      :title="'Add ADL ' + fullName"
    >
      <form @submit.prevent="addEntry">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="adl" class="form-label">ADL</label>
              <select
                class="form-select"
                id="adl"
                v-model="newAdl.adl"
                required
              >
                <option
                  v-for="option in adlActivities"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label for="startdate" class="form-label">Start Date</label>
              <input
                type="date"
                class="form-control"
                id="startdate"
                v-model="newAdl.startdate"
                required
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="detail" class="form-label">Detail</label>
              <textarea
                class="form-control"
                id="detail"
                v-model="newAdl.detail"
              ></textarea>
              <div class="mb-3">
                <label for="enddate" class="form-label">End Date</label>
                <input
                  type="date"
                  class="form-control"
                  id="startdate"
                  v-model="newAdl.enddate"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="adltype" class="form-label">ADL Type</label>
              <select
                class="form-select"
                id="adltype"
                v-model="newAdl.adltype"
                required
              >
                <option
                  v-for="option in adlTypes"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div class="mb-3" v-if="showRoutine">
              <label for="remindTypes" class="form-label">Remind</label>
              <div class="input-group">
                <select
                  class="form-select"
                  id="remind"
                  v-model="newAdl.remind"
                  required
                >
                  <option
                    v-for="option in remindTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
                <select
                  class="form-select"
                  id="minute"
                  v-model="newAdl.minute"
                  required
                >
                  <option
                    v-for="option in minuteTypes"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <!-- Schedules -->
        <h5>Schedules</h5>
        <div class="row">
          <hr />
          <div class="col-md-4">
            <div class="mb-3">
              <label for="time" class="form-label">Time</label>
              <input
                type="time"
                class="form-control"
                id="time"
                v-model="newSchedule.time"
                required
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="type" class="form-label">Type</label>
              <select
                class="form-select"
                id="type"
                v-model="newSchedule.type"
                required
              >
                <option
                  v-for="option in scheduleTypes"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="detail" class="form-label">Detail</label>
              <div v-if="isDaily(newSchedule.type)">
                <div class="d-flex flex-wrap">
                  <div
                    class="form-check me-3"
                    v-for="(day, index) in days"
                    :key="index"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'checkbox' + index"
                      v-model="selectedDays"
                      :value="day"
                      :disabled="isDaily(newSchedule.type)"
                    />
                    <label class="form-check-label" :for="'checkbox' + index">
                      {{ day }}
                    </label>
                  </div>
                </div>
              </div>
              <div v-if="isDWeek(newSchedule.type)">
                <div class="d-flex flex-wrap">
                  <div
                    class="form-check me-3"
                    v-for="(day, index) in days"
                    :key="index"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'checkbox' + index"
                      v-model="selectedDays"
                      :value="day"
                    />
                    <label class="form-check-label" :for="'checkbox' + index">
                      {{ day }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-grid">
            <button type="submit" class="btn btn-primary">Add ADL</button>
          </div>
        </div>
      </form>
      <div v-if="addError" class="alert alert-danger mt-3">
        {{ addError }}
      </div>
    </b-modal>
  </div>
</template>
  
  <script>
import { useQuery, useMutation } from "@vue/apollo-composable";
import {
  GET_ADLS_BY_RESIDENT,
  GET_FULLNAME_BY_ID,
  UPDATE_ADL,
  CREATE_ADL,
  CREATE_SCHEDULE,
  UPDATE_SCHEDULE,
} from "../hooks/queries";
import { ref, computed, watch } from "vue";
import { useRoute } from "vue-router"; // Import useRoute from Vue Router
import {
  adlTypes,
  remindTypes,
  minuteTypes,
  adlActivities,
  formatDate,
  formatDateTimeNormal,
  getBread,
  getUserRole,
  scheduleTypes,
  formatTimeHHMMSSMMM,
  formatTimeHHMM,
} from "../components/values";

export default {
  name: "ResADL",

  setup() {
    const route = useRoute(); // Use useRoute to get the current route
    const residentId = route.params.id; // Access the route parameter directly
    const { result:result, loading:loading, error:error, refetch:refetch } = useQuery(GET_ADLS_BY_RESIDENT, {
      residentId: residentId,
    });
    
    const {result:resultfullname, loading:loadingfullname, error:errorfullname, refetch:refetchfullname } = useQuery(GET_FULLNAME_BY_ID, {
      id: residentId,
    });

   
    // Watch the result and compute the full name only when the data is available
    const fullName = computed(() => {
      const data = resultfullname.value?.resident?.data;
      if (data) {
        return `(${data.attributes.firstname} ${data.attributes.lastname})`;
      }
      return null;
    });

   

    const { mutate: updateResidentadl } = useMutation(UPDATE_ADL);
    const { mutate: createAdl } = useMutation(CREATE_ADL);
    const { mutate: createSchedule } = useMutation(CREATE_SCHEDULE);
    const { mutate: updateResidentschedule } = useMutation(UPDATE_SCHEDULE);
    const currentAdl = ref(null);
    const currentSchedules = ref(null);
    const updateError = ref(null);
    const addError = ref(null);
    const showEditModal = ref(false);
    const showAddModal = ref(false);
    const showViewModal = ref(false);
    const now = new Date().toISOString().slice(0, 9);

    const days = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];

    const selectedDays = ref([]);

    const newSchedule = ref({
      time: "",
      type: "",
      publishedAt: new Date().toISOString(),
    });

    const newAdl = ref({
      startdate: now,
      adltype: "",
      adl: "",
      detail: "",
      remind: "",
      minute: "",
      publishedAt: new Date().toISOString(),
    });

    const addEntry = async () => {
      addError.value = null;
      try {
        const adlResponse = await createAdl({
          data: {
            resident: residentId, // Include the residentId in the input data
            adltype: newAdl.value.adltype,
            adl: newAdl.value.adl,
            startdate: newAdl.value.startdate,
            enddate: newAdl.value.enddate,
            detail: newAdl.value.detail,
            remind: newAdl.value.remind,
            minute: newAdl.value.minute,
            publishedAt: new Date().toISOString(),
          },
        });
        // Extract the ID from the response
        const adlId = adlResponse.data.createResidentadl.data.id;

        //if (!adlId) {
        //throw new Error("Failed to retrieve ADL ID");
        //}

        //console.log(adlResponse.data.createResidentadl.data.id);

        await createSchedule({
          data: {
            residentadl: adlId, // Include the ADL ID in the schedule data
            type: newSchedule.value.type,
            time: formatTimeHHMMSSMMM(newSchedule.value.time),
            mo: selectedDays.value.includes("Mo"),
            tu: selectedDays.value.includes("Tu"),
            we: selectedDays.value.includes("We"),
            th: selectedDays.value.includes("Th"),
            fr: selectedDays.value.includes("Fr"),
            sa: selectedDays.value.includes("Sa"),
            su: selectedDays.value.includes("Su"),
            publishedAt: new Date().toISOString(),
          },
          returnFields: `id`,
        });
        showAddModal.value = false;
        newAdl.value = {
          startdate: now,
          adltype: "",
          adl: "",
        };
        newSchedule.value = {
          time: "",
          type: "",
        };
        await refetch(); // Refetch the list after adding a new one
        await refetchfullname();
      } catch (e) {
        //console.error("Error adding entry:", e);
        addError.value = `Failed to add. Please try again.`;
      }
    };

    const isRoutine = (value) => {
      const option = adlTypes.find((option) => option.value === value);
      return option.showRoutine;
    };

    const showRoutine = computed(() => {
      const selectedOption = adlTypes.find(
        (option) => option.value === newAdl.value.adltype
      );
      return selectedOption ? selectedOption.showRoutine : false;
    });

    const loadScheduleDays = (schedule) => {
      schedule.selectedDays = days.filter(
        (day) => schedule.attributes[day.toLowerCase()]
      );
    };

    const loadDays = (schedules) => {
      schedules.forEach((schedule) => {
        watch(
          () => schedule.attributes.type,
          (newType) => {
            if (isDaily(newType)) {
              schedule.selectedDays.length = 0;
              schedule.selectedDays.push("Mo");
              schedule.selectedDays.push("Tu");
              schedule.selectedDays.push("We");
              schedule.selectedDays.push("Th");
              schedule.selectedDays.push("Fr");
              schedule.selectedDays.push("Sa");
              schedule.selectedDays.push("Su");
            }
            if (isDWeek(newType)) {
              schedule.selectedDays.length = 0;
              if (schedule.attributes.mo) schedule.selectedDays.push("Mo");
              if (schedule.attributes.tu) schedule.selectedDays.push("Tu");
              if (schedule.attributes.we) schedule.selectedDays.push("We");
              if (schedule.attributes.th) schedule.selectedDays.push("Th");
              if (schedule.attributes.fr) schedule.selectedDays.push("Fr");
              if (schedule.attributes.sa) schedule.selectedDays.push("Sa");
              if (schedule.attributes.su) schedule.selectedDays.push("Su");
            }
          }
        );
      });
    };

    const editEntry = (adl) => {
      currentAdl.value = JSON.parse(JSON.stringify(adl));
      currentSchedules.value = JSON.parse(
        JSON.stringify(adl.attributes.residentschedules.data)
      );

      currentSchedules.value.forEach((schedule) => {
        loadScheduleDays(schedule);
      });

      loadDays(currentSchedules.value);

      showEditModal.value = true;
    };

    const updateEntry = async () => {
      updateError.value = null; // Reset the error message
      try {
        await updateResidentadl({
          id: currentAdl.value.id,
          data: {
            adltype: currentAdl.value.attributes.adltype,
            startdate: currentAdl.value.attributes.startdate,
            adl: currentAdl.value.attributes.adl,
            detail: currentAdl.value.attributes.detail,
            enddate: currentAdl.value.attributes.enddate,
            minute: currentAdl.value.attributes.minute,
            remind: currentAdl.value.attributes.remind,
          },
        });

        for (const schedule of currentSchedules.value) {
          
          await updateResidentschedule({
            id: schedule.id,
            data: {
              type: schedule.attributes.type,
              time: formatTimeHHMMSSMMM(schedule.attributes.time),
              mo: schedule.selectedDays.includes("Mo"),
              tu: schedule.selectedDays.includes("Tu"),
              we: schedule.selectedDays.includes("We"),
              th: schedule.selectedDays.includes("Th"),
              fr: schedule.selectedDays.includes("Fr"),
              sa: schedule.selectedDays.includes("Sa"),
              su: schedule.selectedDays.includes("Su"),
            },
          });
        }

        //console.log("Updated entry:", currentAdl.value);
        showEditModal.value = false;
      } catch (error) {
        //console.error("Error updating entry:", error);
        updateError.value = "Failed to update Adl. Please try again.";
      }
    };
    const viewEntry = (adl) => {
      currentAdl.value = JSON.parse(JSON.stringify(adl)); // Create a deep copy of the ADL object
      currentSchedules.value = JSON.parse(
        JSON.stringify(adl.attributes.residentschedules.data)
      );
      showViewModal.value = true;
    };

    const getAdlTypeText = (value) => {
      const option = adlTypes.find((option) => option.value === value);
      return option ? option.text : "";
    };

    const getRemindTypeText = (value) => {
      const option = remindTypes.find((option) => option.value === value);
      return option ? option.text : "";
    };
    const getMinuteTypeText = (value) => {
      const option = minuteTypes.find((option) => option.value === value);
      return option ? option.text : "";
    };
    const getAdlActivities = (value) => {
      const option = adlActivities.find((option) => option.value === value);
      return option ? option.text : "";
    };

    const isDaily = (value) => {
      const option = scheduleTypes.find((option) => option.value === value);
      return option ? option.showDaily : false;
    };

    const isDWeek = (value) => {
      const option = scheduleTypes.find((option) => option.value === value);
      return option ? option.showDWeek : false;
    };

    // Watcher for newSchedule type to automatically select all days if type is daily
    watch(
      () => newSchedule.value.type,
      (newValue) => {
        if (isDaily(newValue)) {
          selectedDays.value = days.slice(); // Select all days
        } else {
          selectedDays.value = []; // Clear selection if not daily
        }
      }
    );

    return {
      result,
      resultfullname,
      loading,
      days,
      error,
      formatDate,
      showEditModal,
      showAddModal,
      showViewModal,
      currentAdl,
      currentSchedules,
      newAdl,
      editEntry,
      updateEntry,
      addEntry,
      viewEntry,
      updateError,
      addError,
      adlTypes,
      formatDateTimeNormal,
      getAdlTypeText,
      getAdlActivities,
      adlActivities,
      remindTypes,
      minuteTypes,
      getRemindTypeText,
      getMinuteTypeText,
      showRoutine,
      isRoutine,
      getBread,
      getUserRole,
      residentId,
      scheduleTypes,
      formatTimeHHMMSSMMM,
      formatTimeHHMM,
      isDaily,
      isDWeek,
      selectedDays,
      newSchedule,
      fullName,
      errorfullname,
      loadingfullname
    };
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(
        this.result.residentadls.data.length / this.itemsPerPage
      );
    },
    paginatedAdls() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.result.residentadls.data.slice(
        start,
        start + this.itemsPerPage
      );
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return Math.min(
        this.startIndex + this.itemsPerPage,
        this.result.residentadls.data.length
      );
    },
    /**
    fullName() {
      let residentFullName = "";
      if (
        this.result &&
        this.result.residentadls &&
        this.result.residentadls.data.length > 0
      ) {
        const resident = this.result.residentadls.data[0].attributes.resident;

        if (resident && resident.data && resident.data.attributes) {
          residentFullName =
            "(" +
            resident.data.attributes.firstname +
            " " +
            resident.data.attributes.lastname +
            ")";
        }
      }
      return residentFullName;
    },
     */

    formattedDateRecorded: {
      get() {
        return this.formatDateTimeEdit(this.currentAdl.attributes.startdate);
      },
      set(newValue) {
        this.currentAdl.attributes.startdate = newValue;
      },
    },
  },
  methods: {
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },

    formatDateTimeEdit(dateTime) {
      // Create a Date object from the input date-time string
      let date = new Date(dateTime);

      // Format the date and time to 'YYYY-MM-DDTHH:MM'
      let formattedDate = date.toISOString().slice(0, 16);

      return formattedDate;
    },
  },
};
</script>
  
  <style>
.container {
  max-width: 80%;
}

.d-grid {
  background-color: #e8e8e8;
  margin-bottom: 20px;
}

.text-center {
  text-align: center;
}
.spinner-border {
  margin-top: 20px;
}
.pagination {
  margin: 0;
}
</style>
  
